import { render, staticRenderFns } from "./AddDataInBulkModal.vue?vue&type=template&id=b3e2d2e6"
import script from "./AddDataInBulkModal.vue?vue&type=script&lang=js"
export * from "./AddDataInBulkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports